import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersonApi } from '../+api';
import { CurriculumTreeConceptInterface } from '../+models';

@Injectable({
  providedIn: 'root',
})
export class CurriculumTreeConceptService {
  constructor(private personApi: PersonApi) {}

  getAllForUser(userId: number): Observable<CurriculumTreeConceptInterface[]> {
    return this.personApi
      .getData(userId, 'curriculumTreeConcepts')
      .pipe(map((res: { curriculumTreeConcepts: CurriculumTreeConceptInterface[] }) => res.curriculumTreeConcepts));
  }
}
